module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div tabindex="0" class="apexchat_overlay_content">\r\n    <div style="font-size: 14px; color: #fff">\r\n        The previous chat session has ended\r\n    </div>\r\n    <div style="margin-top: 10px;margin-bottom: 10px;">\r\n        <button class="apexchat_new_chat_start livechat_button livechat_button_large livechat_primary_button"\r\n            tabindex="0">\r\n            Start New Chat\r\n        </button>\r\n        <button class="apexchat_closebtn livechat_button livechat_button_text livechat_button_text_dull">\r\n            Close\r\n        </button>\r\n    </div>\r\n</div>';

}
return __p
}